/****************************
*   
*   Pantomime Paty (c) 2022
*
*   Author: Oliver Borner 
*   oliverborner@gmail.com
*
*****************************/

<template>
	<div>
		<div class="pb-4">
			<button type="button" class="btn btn-warning chooseall" @click="selectAll(); playSound('sounds/click2.mp3')"><b-icon-check2-all></b-icon-check2-all> Alle auswählen</button>
			<button type="button" class="btn btn-warning chooseall" @click="clearAll(); playSound('sounds/click2.mp3')"><b-icon-x class="pb-1" scale="1.5"></b-icon-x> Alle abwählen</button>
		</div>

		<swiper class="swiper-container" ref="mySwiper" :options="swiperOptions">

			<swiper-slide class="swiper-slide" v-for="(item, index) in allCategories" :key="index">

				<ul id="cat-card" :class="[!item[1].active || item[1].locked === true ? 'category-card': 'category-card-checked']" @click="toggleActiveState(item); playSound('sounds/slide.mp3')">
					<li class="category-image"><img :src="item[1].logo_url" ></li>	
					<li><h3>{{ item[0] }}</h3></li>
					<li><p class="category-descr">{{ item[1].description }}</p></li>
					<span class="icon-checked" v-if="item[1].active && !item[1].locked"><b-icon-check2-circle scale="2" ></b-icon-check2-circle></span>
				</ul>
			
				<span class="icon-circle" v-if="item[1].locked"><b-icon-lock-fill></b-icon-lock-fill></span>
				
			</swiper-slide>
			<!-- Desktop Only -->
	<!-- 		<div class="swiper-button-next"></div>
			<div class="swiper-button-prev"></div> -->
			<div class="swiper-button-prev" slot="button-prev" @click="$refs.mySwiper.$swiper.slidePrev()"></div>
			<div class="swiper-button-next" slot="button-next" @click="$refs.mySwiper.$swiper.slideNext()"></div>
		</swiper>
		
        <button type="button" class="btn btn-success wiggle  play-cat" @click="startGame()">
			<div class="p-button-play">
				<span class="play-cat-button">Spielen</span>
				<span class=""><b-icon-controller scale="1.4"></b-icon-controller></span>
			</div>
		</button>

		<!-- MODAL - Alert -->
        <transition name="fade">
            <div id="p-modal" v-if="modalAlert">
                <div class="settings-menu">
					<div class="hero-card-img">
						<img src="../assets/images/logo/default.svg" class="slide-top" width="55px">
					</div>
                    <p class="settings-entry-heading text-center">
                        Es muss mindestens eine Kategorie ausgewählt werden!
                    </p>

					<button type="button" class="btn btn-danger center w-100 mt-4" @click="modalAlert = false">Ok</button>

					<!-- <div class="close-menu">
						<b-icon-x class="pt-1" scale="2" @click="modalAlert = false"></b-icon-x>
					</div> -->
				</div>
			</div>
		</transition>

		<!-- MODAL - Download App-->
		<transition name="fade">
            <div id="p-modal" v-if="modalApp">
                <div class="settings-menu">
					<div class="hero-card-img">
						<img src="../assets/images/logo/default.svg" class="slide-top" width="55px">
					</div>
                    <p class="settings-entry-heading text-center">
                        Lade die App herunter um alle Kategorien freizuschalten.
                    </p>

					<button type="button" class="btn btn-danger center w-100 mt-4" @click="modalApp = false">Ok</button>

					<!-- <div class="close-menu">
						<b-icon-x class="pt-1" scale="2" @click="modalApp = false"></b-icon-x>
					</div> -->
				</div>
			</div>
		</transition>
	
	</div>
</template>

<script>
import { SwiperSlide, directive } from 'vue-awesome-swiper'

export default {
	components: {
		SwiperSlide, 
	},
	props:[
		'allCategories',
	],
	data() {
		return {
			checkedAll: true,
			modalAlert: false,
			modalApp: false,
			checked: false,
			swiperOptions: {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				}, 
				effect: "coverflow",
				grabCursor: true,
				centeredSlides: true,
				slidesPerView: "auto",
				initialSlide: 0, 
				preventClicks: false,
				loop: false,
				loopedSlides: this.allCategories.length,
				/* on: {
				slideChange: function () {
					let lastVisibleItem = this.realIndex + this.params.slidesPerView
					let slidesLength = this.slides.length - 2
					let lastVisibleIndex = this.realIndex + this.params.slidesPerView
					// if swiper reaches the end of displayed items, goToNext redirects swiper to the start
					if (lastVisibleItem > slidesLength) {
						this.slideTo(1)
					}
					// if swiper wants to go before the first item, then forward swiper to the last item
					if (lastVisibleIndex >= this.slides.length) {
						this.slideTo((slidesLength - this.params.slidesPerView) + 1)
					}
				}
				}, */
				preventClicksPropagation: false,
				coverflowEffect: {
					rotate: 20,
					stretch: 0,
					depth: 350,
					modifier: 1,
					slideShadows: true
				},
			}
		}
	},

	directives: {
		swiper: directive
	},

	mounted() {

	},
	updated() {
		// console.log(this.allCategories)
	},

	methods:{
		clearAll() {
			
			Object.entries(this.allCategories).forEach(val => {
				if(!val[1][1].locked) {
					val[1][1].active = false;
				}
			});

			// locked items no class change plz!
			document.querySelectorAll('#cat-card').forEach(e => e.classList.remove('category-card-checked'));
			document.querySelectorAll('#cat-card').forEach(e => e.classList.add('category-card')); 
		
		},

		selectAll() {
			
			Object.entries(this.allCategories).forEach(val => {
				if(!val[1][1].locked) {
					val[1][1].active = true;
				}
			});

			// locked items no class change plz!
			document.querySelectorAll('#cat-card').forEach(e => e.classList.remove('category-card'));
			document.querySelectorAll('#cat-card').forEach(e => e.classList.add('category-card-checked')); 

		},

		startGame() {
			let counter = 0;

			Object.entries(this.allCategories).forEach(val => {
                if (val[1][1].active) {
					counter++;
				}
			});

			if(counter > 0) {
				this.$parent.newRound();
			} else {
				this.modalAlert = true;
			}
		},

		toggleActiveState(item) {
			if(!item[1].locked) {
				if (item[1].active) {

					item[1].active = false;

					Object.entries(this.allCategories).forEach(val => {
						if (val[1][0] === item[0]) {
							val[1][1].active = false;
						}
					});
				
				}
				else {

					item[1].active = true;

					Object.entries(this.allCategories).forEach(val => {
						if (val[1][0] === item[0]) {
							val[1][1].active = true;
						}
					});
				}
			}
			else {
				// App kaufen
				this.modalApp = true;
			}

		},
		playSound (sound) {
            if(this.$parent.hasSound){
                if(sound) {
                    var audio = new Audio(sound, {formats: [ "mp3" ], preload: true});
                    audio.play();
                }
            }
        },

	},

}
</script>
